module.exports = __webpack_public_path__ + "static/rangleLogo-3aa2826c41dcf6717fb0290d548a486a.png";